import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchFormConfigurationRequest = createAction("".concat(stateName, "/fetchFormConfigurationRequest"));
export const fetchFormConfigurationFailure = createAction("".concat(stateName, "/fetchFormConfigurationFailure"));